import { Injectable, inject } from '@angular/core';
import { StateService } from '@uirouter/core';
import { SpacesService } from 'account-hybrid/common/components/spaces';

/**
 * WS5 #10 inc 2i-2: native port of the angularjs.module.ts run-block
 * `$on('curationModal.openDetails')` handler — navigates to the context-appropriate
 * advocate/details child state. The v1 handler dispatched redux-ui-router's `stateGo`
 * through `$ngRedux`; its only observable effect is `$state.go` (the ng-redux `router`
 * slice has NO reader anywhere in the worktree — census 2026-06-10), so the native
 * UIRouter StateService.go is equivalent. The byte-identical "/undefined/<uuid>"
 * context param is preserved (WS2 Step 5: singleProperty always equals
 * SpacesService.getPropertyUuid(); organization never existed → 'undefined').
 *
 * The three former broadcasters (contest-winners, curation-modal-host, story-modal)
 * call this directly — the `curationModal.openDetails` $rootScope event is gone.
 */
@Injectable({ providedIn: 'root' })
export class CurationDetailsNavigatorService {
  private readonly stateService = inject(StateService);
  private readonly spacesService = inject(SpacesService);

  openDetails(guestUuid: string): void {
    let state = `${this.stateService.current.name}.details`;
    if (/advocacy\.audiences/.test(this.stateService.current.name)) {
      state = 'advocacy.audiences.advocate';
    } else if (/advocacy\.contests/.test(this.stateService.current.name)) {
      state = 'advocacy.contests.advocate';
    } else if (/stories/.test(this.stateService.current.name)) {
      state = 'stories.details';
    }
    const fullContext = `/undefined/${this.spacesService.getPropertyUuid()}`;
    this.stateService.go(state, { advocateUUID: guestUuid, context: fullContext });
  }
}
